import { ErrorHandler } from '@angular/core';

export class AppGlobalErrorhandler implements ErrorHandler {
  constructor() {}

  handleError(error: Error) {
    console.error(error);

    try {
      (window as any).newrelic.noticeError(error);
    } catch (e) {
      console.info('Error sending log to newrelic', e);
    }
  }
}
